import config from '@config';
import { MastercardPostPaymentBanner } from '@shared/ui/banner/MastercardPostPaymentBanner';
import { useGetHelpStatisticQuery } from '@store/api/landing.api';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface ModalBodyGratitudeOnlineProps {
  variant?: 'for-members' | 'for-guests';
  bonus: number;
}

export const ModalBodyGratitudeOnline: React.FC<ModalBodyGratitudeOnlineProps> = ({
  bonus,
  variant = 'for-members',
}) => {
  const { t } = useTranslation();
  const { data: statisticData } = useGetHelpStatisticQuery();

  const volunteersAmount = statisticData?.statistic.volunteers ?? 100;

  const Content = useCallback(() => {
    if (variant === 'for-members') {
      return (
        <div>
          {t('payment-was-successfull')}{' '}
          <b className="font-medium">
            “{t('in-progress')}”. {t('go')}
          </b>{' '}
          <b className="font-medium">{t('or-stay')}</b>
        </div>
      );
    }

    if (variant === 'for-guests') {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: t('successfull-payment-guest', { totalVolunteers: volunteersAmount }) }}
        />
      );
    }

    return null;
  }, [t, variant, volunteersAmount]);

  return (
    <div className="text-xs font-light">
      <Content />
      {/* {(bonus > 0 || bonus === -1) && config.payments.mastercardBonusEnabled && (
        <MastercardPostPaymentBanner bonus={bonus} className="mt-8" />
      )} */}
    </div>
  );
};
